import { handleCalculatePercent } from "@lib/helpers/Common";
import { InvoiceItem } from "@lib/types/Billing";

export const priceTimesQuantity = (item: InvoiceItem): number => {
  return (item?.unitPrice || 0) * (item?.quantity || 1) || 0;
};

export const itemTotalPrice = (item: InvoiceItem): number => {
  return priceTimesQuantity(item) - (item?.discount || 0);
  return (
    handleCalculatePercent(priceTimesQuantity(item), item?.discount || 0) || 0
  );
};
